// A user message that opens a turn the server starts. Only a proactive agent's chat shows it.
export const isSystemNote = (message: {
  role: string;
  content: string | null | undefined;
}) =>
  message.role === 'user' &&
  (message.content?.trimStart() ?? '').startsWith('<system>');
